import { render, staticRenderFns } from "./left_3.vue?vue&type=template&id=19a50873&scoped=true&"
import script from "./left_3.vue?vue&type=script&lang=js&"
export * from "./left_3.vue?vue&type=script&lang=js&"
import style0 from "./left_3.vue?vue&type=style&index=0&id=19a50873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a50873",
  null
  
)

export default component.exports